var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100",attrs:{"id":"app"}},[_c(_vm.path_layout,{tag:"component",scopedSlots:_vm._u([{key:"navbar-items",fn:function(){return [_c('navbar-items')]},proxy:true}])},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }